const MAX_SOURCE_BYTES = 15 * 1024 * 1024;
const MAX_OUTPUT_BYTES = 2_400_000;
const MAX_EDGE = 1_600;

function readAsDataUrl(file: Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("读取图片失败，请重新选择"));
    reader.readAsDataURL(file);
  });
}

function loadImage(dataUrl: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("当前浏览器无法读取该图片，请使用 JPG 或 PNG"));
    image.src = dataUrl;
  });
}

function canvasBlob(canvas: HTMLCanvasElement, quality: number) {
  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("图片压缩失败，请重新选择")), "image/jpeg", quality);
  });
}

export async function prepareOcrImage(file: File) {
  if (!file.type.startsWith("image/")) throw new Error("请选择图片文件");
  if (file.size > MAX_SOURCE_BYTES) throw new Error("原图超过 15MB，请先裁剪后再上传");
  const sourceUrl = await readAsDataUrl(file);
  const image = await loadImage(sourceUrl);
  if (image.naturalWidth < 15 || image.naturalHeight < 15) throw new Error("图片尺寸过小，无法识别");
  const scale = Math.min(1, MAX_EDGE / Math.max(image.naturalWidth, image.naturalHeight));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext("2d", { alpha: false });
  if (!context) throw new Error("当前浏览器不支持图片处理");
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  let blob = await canvasBlob(canvas, 0.82);
  if (blob.size > MAX_OUTPUT_BYTES) blob = await canvasBlob(canvas, 0.66);
  if (blob.size > MAX_OUTPUT_BYTES) throw new Error("图片压缩后仍过大，请裁剪作业区域后重试");
  return {
    dataUrl: await readAsDataUrl(blob),
    bytes: blob.size,
    width: canvas.width,
    height: canvas.height,
  };
}
